window.newsHash = window.location.hash;
window.onload = function() {
  document.cookie = 'MCPopupClosed=;path=/;expires=Thu, 01 Jan 1970 00:00:00 UTC;';
  document.cookie = 'MCPopupSubscribed=;path=/;expires=Thu, 01 Jan 1970 00:00:00 UTC;';

  document.getElementById('open-mc-popup').onclick = function(e) { 
    e.preventDefault();

    window.dojoRequire(["mojo/signup-forms/Loader"], function(L) { 
      L.start({"baseUrl":"mc.us14.list-manage.com","uuid":"e61e2fe924247a3673bb60533","lid":"ddd8a70d1d","uniqueMethods":true});
      
      document.cookie = 'MCPopupClosed=;path=/;expires=Thu, 01 Jan 1970 00:00:00 UTC;';
      document.cookie = 'MCPopupSubscribed=;path=/;expires=Thu, 01 Jan 1970 00:00:00 UTC;';
    }); 
  };

  jQuery(function ($) {
    'use strict';

    var newsIsSetup = false;

    $('.cover-slides').flexslider({
      animation: 'fade',
      animationSpeed: 1200,
      controlNav: true,
      animationLoop: true,
      slideshow: false,
      prevText: '',
      nextText: ''
    });

    $('body').on('click', 'a[data-target]', function (e) {
      e.preventDefault();

      var target = $(e.target).data('target'),
          activeModal = $('.modal.in'),
          modal = $('#' + target);

      history.pushState({ current: target, prev: history.state.current, isModal: true }, '', '/' + target);

      modal.on('shown.bs.modal', function () {
        $(window).trigger('resize');
      });

      if ( activeModal.length > 0 ) {
        activeModal.addClass('out');
        setTimeout(function() {
          activeModal.removeClass('out');
          activeModal.modal('hide');
          modal.modal('show');
        }, 1000);
      } else {
        modal.modal('show');
      }

    });

    $('.btn-close-modal, .logo').on('click', function(e) {
      $('body').removeClass('modal-open');

      var activeModal = $('.modal.in');
      activeModal.addClass('out');
      history.pushState({ current: '/', prev: history.state.current }, '', '/');
      setTimeout(function() {
        activeModal.removeClass('out');
        activeModal.modal('hide');
      }, 1000);
    });

    /* Start news setup */
    setupNews();

    $('.form').on('submit', function (e) {

      e.preventDefault();

      var f = $(this);

      f.addClass('sending');

      var message = '';
      f.find('label').each(function() {
      var l = $(this);
      message += l.find('span').data('title') + ': ' + l.find('input, textarea').eq(0).val() + '<br />';
      });

      sendMail( message )
      .done(function() {
        f.removeClass('sending').addClass('sent');
      });

    });

    $('.form-go-back').on('click', function() {
      $('.btn-close-modal').click();
      var f = $(this).closest('.form');
      f.find('input:not([type="submit"]), textarea').val('');
      setTimeout(function() {
      f.removeClass('sending, sent');    
      }, 1000);
    });

    // Start history
    history.pushState({ current: '/', prev: null }, '', '/');

    window.onpopstate = function(e) {
      if ( e.state.isModal ) {
      $('#' + e.state.current).modal('show');
      // Just make sure if modal is news, it is reset
      setTimeout(function () {
        toggleNewsView(true)
      }, 1000);
      } else if ( e.state.isNews ) {
      openNewsItem(e.state.current);
      } else {
      $('.modal.in').modal('hide');
      }

    };

    if ( window.newsHash ) {
      var slug = window.newsHash.replace('#', '');
      if ( $('.news-list').find('[data-post_slug="' + slug + '"]').length > 0 ) {
      openNewsItem(slug);
      }
    }

    /* Video modal setup */
    var videoBtns = document.querySelectorAll('.open-video-modal');
    for (var i=0; i<videoBtns.length; i++) {
       videoBtns[i].addEventListener('click', openVideoModal)
     }
  });

  /* News handling */
  function setupNews() {
    $('.news-list').on('click', '.more-link', function (e) {

      e.preventDefault();

      var post_id = $(this).closest('.item').data('post_id');
      var post_slug = $(this).closest('.item').data('post_slug');

      history.pushState({ current: post_slug, prev: history.state.current, isNews: true }, '', '/news/' + post_slug);

      updatePostPage( post_id );
      toggleNewsView(true);

    });

    $('.news-item').on('click', '.back', function (e) {
      e.preventDefault();
      history.pushState({ current: 'news', prev: history.state.current }, '', '/news');
      toggleNewsView(false);
    });

    newsIsSetup = true;
  }
  
  function sendMail ( message ) {
    return $.post(window.themeURL + '/sendMail.php', { 'message': message });
  }

  function openNewsItem (slug) {
    $('#news').modal('show');
    setTimeout(function () {
      $('.news-list').find('[data-post_slug="' + slug + '"]').closest('.item').find('.more-link').eq(0).click();
    }, 1000);
  }

  // Handle video modal
  function openVideoModal(e) {
    e.preventDefault();

    var modal = document.querySelector('.video-modal'),
        embedCode = modal.querySelector('.embed-code').value,
        videoWrapper = modal.querySelector('.video-wrapper');
    
    // Start video
    videoWrapper.innerHTML = embedCode;
    
    modal.classList.add('active');
    setTimeout(function() {
      modal.classList.add('visible');
    }, 10);

    var btnCloseModalClick = function(e) {
      e.preventDefault();
      this.removeEventListener('click', btnCloseModalClick);
      modal.classList.remove('visible');
      setTimeout(function() {
        modal.classList.remove('active');
        // Stop video
        videoWrapper.innerHTML = '';
      }, 600);
    };
    modal.querySelector('.btn-close-video-modal').addEventListener('click', btnCloseModalClick)

  }

  function toggleNewsView( showMainPage ) {
    var wrap = $('.news-wrap');
    if ( showMainPage ) {
      wrap.addClass('post-view');
      setTimeout(function() {
        $('.news-list').css('max-height', '0');
      }, 1000);
    } else {
      $('.news-list').css('max-height', 'initial');
      wrap.removeClass('post-view');
      setTimeout(function() {
        updatePostPage();
      }, 1000);
    }
  }

  function updatePostPage( post_id ) {
    var item = $('.news-item');

    if ( post_id ) {
      item.find('.body').hide();
      item.find('.loading').show();
      item.find('.thumbnail-box').hide();

      $.get('/wp-json/wp/v2/posts/' + post_id)
        .done(function (post) {

          item.find('.title').html(post.title.rendered);
          item.find('.content').html(post.content.rendered);

          item.find('.gallery').html('');
          if ( post.gallery ) {
            var gallery = item.find('.gallery');
            for (var i in post.gallery) {
              var imgClass = (post.gallery[i].thumbnail_width >= post.gallery[i].thumbnail_height) ? 'landscape' : 'portrait';
              $('<a>', {
              'href': post.gallery[i].url,
              'rel': post.slug,
              'html': $('<img>', { 'src': post.gallery[i].thumbnail, 'class': imgClass })
              }).appendTo(gallery);
            }
            gallery.find('a').fancybox({
              'padding': 0
            });
          }

        jQuery('.modal').scrollTop(0);

        item.find('.loading').fadeOut(function () {
        item.find('.body').fadeIn();
        });

      });
    } else {
      item.find('.title').html('');
      item.find('.content').html('');
      item.find('.gallery').html('');
    }
  }
};